import React from "react";
import PropTypes from "prop-types";

/**
 * GetQwotedCTA — the anonymous "Get Qwoted" sign-up affordance for profile pages.
 *
 * A brand-purple, fully-rounded pill fixed to the bottom-right of the viewport: a floating
 * conversion prompt for logged-out visitors. Chrome only — it renders whenever mounted and does
 * not decide its own visibility; call sites gate it on the viewer being anonymous, mirroring how
 * FollowControl is hidden for viewers who can edit the page. btn-primary is the brand purple
 * (#533dd1); z-index sits below Bootstrap's modal/offcanvas layers (~1050) so a dialog always
 * covers it, but above ordinary page content.
 *
 * @param {Object} props
 * @param {string} [props.href] - Sign-up URL (defaults to the Account engine's sign_up route)
 * @param {string} [props.label] - Button text
 * @param {string} [props.className] - Extra classes appended to the pill
 */
function GetQwotedCTA({ href = "/account/sign_up", label = "Get Qwoted", className = "" }) {
  return (
    <a
      href={href}
      className={`btn btn-primary btn-lg rounded-pill shadow position-fixed bottom-0 end-0 m-4 ${className}`.trim()}
      style={{ zIndex: 1030 }}
    >
      {label}
    </a>
  );
}

GetQwotedCTA.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default GetQwotedCTA;
